import { render, staticRenderFns } from "./LegacyPressePost.vue?vue&type=template&id=d8c46958&"
import script from "./LegacyPressePost.vue?vue&type=script&lang=js&"
export * from "./LegacyPressePost.vue?vue&type=script&lang=js&"
import style0 from "./LegacyPressePost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports